import { defaults } from 'lodash';
import { renderAsElement } from './utils';

export class Tooltips {
  defaults = {
    selector: '[data-tooltip]',
    tip: '',
    template: (tooltip) => {
      return ['<div class="tooltip rounded z-9999" data-tooltip>', '<p>' + tooltip.tip + '</p>', '</div>'].join('');
    },
  };

  constructor() {
    document.addEventListener('mouseover', this.mouseoverHandler.bind(this), false);
    document.addEventListener('mouseout', this.mouseoutHandler.bind(this), false);
    document.addEventListener('click', this.clickHandler.bind(this), false);
    document.addEventListener('touchstart', this.mouseoverHandler.bind(this), false);
    console.log('Tooltips initialised');
  }

  mouseoverHandler(event) {
    let tooltip = event.target.closest('[data-tooltip]');
    if (tooltip) return;

    let target = event.target.closest('[data-tooltip-trigger]');
    if (!target) return;

    let tip = target.getAttribute('data-title');
    if (!tip || tip == '') return;

    event.preventDefault();
    this.create(target, {
      tip: tip,
    });
  }

  mouseoutHandler(event) {
    let tooltip = event.target.closest('[data-tooltip-trigger]');
    if (tooltip) {
      let openTips = document.querySelectorAll('[data-tooltip]');
      if (!openTips) return;
      openTips.forEach((tip) => {
        tip.remove();
      });
      return;
    }
  }

  clickHandler(event) {
    let tooltip = event.target.closest('[data-tooltip]');
    if (tooltip) {
      this.destroy(tooltip);
    }
  }

  create(target, options) {
    let localSettings = defaults(options || {}, this.defaults);
    let tooltip = renderAsElement(localSettings.template, localSettings);

    document.body.appendChild(tooltip);
    this.position(target, tooltip);
  }

  position(target, tooltip) {
    if (window.innerWidth < tooltip.offsetWidth * 1.5) {
      tooltip.style.maxWidth = window.innerWidth / 2 + 'px';
    } else {
      tooltip.style.maxWidth = '340px';
    }

    let rect = target.getBoundingClientRect();
    let targetOffsetY = window.pageYOffset + rect.top;

    let pos_left = rect.left + target.offsetWidth / 2 - tooltip.offsetWidth / 2;
    let to_top = rect.top - tooltip.offsetHeight - 20;

    if (pos_left < 0) {
      pos_left = rect.left + target.offsetWidth / 2 - 20;
      tooltip.classList.add('left');
    } else {
      tooltip.classList.remove('left');
    }

    if (pos_left + tooltip.offsetWidth > window.innerWidth) {
      pos_left = rect.left - tooltip.offsetWidth + target.offsetWidth / 2 + 20;
      tooltip.classList.add('right');
    } else {
      tooltip.classList.remove('right');
    }

    let pos_top;
    if (to_top < 0) {
      pos_top = targetOffsetY + target.offsetHeight + 8;
      tooltip.classList.add('top');
    } else {
      pos_top = targetOffsetY - tooltip.offsetHeight - 8;
      tooltip.classList.remove('top');
    }

    tooltip.style.left = pos_left + 'px';
    tooltip.style.top = pos_top + 'px';
  }
}
